import React from "react";
import PropTypes from "prop-types";

import {
  StyledButtonWrapper,
  StyledButton
} from "./styles";

export const ButtonGridLayout = ({
  context = null,
  clientContext = null,
  path = null,
  onClick = null,
  label = null,
  type = "lightMode", // Options: 'lightMode', 'darkMode',
  padding = "0px",
}) => {
    if (path !== undefined && path !== null) {
      return (
        <StyledButtonWrapper padding={padding}>
          <StyledButton type={type} href={path} onClick={onClick}>
            {label}
          </StyledButton>
        </StyledButtonWrapper>
      );
    }
    return (
      <StyledButtonWrapper padding={padding}>
        <StyledButton type={type} onClick={onClick}>
          {label}
        </StyledButton>
      </StyledButtonWrapper>
    );
};

export default ButtonGridLayout;

ButtonGridLayout.propTypes = {
  /**
   Client side variables
  */
  clientContext: PropTypes.object,
  /**
   Server side variables
  */
  context: PropTypes.object,
  /**
   Child objects
  */
  label: PropTypes.string,
  /**
   Path (link)
  */
  path: PropTypes.string,
  /**
   Click handler function
  */
  onClick: PropTypes.func,
  /**
   Type of display style
  */
  type: PropTypes.string,
  padding: PropTypes.string,
};
